const FILTER_TYPE = 'talent_candidate_recommended_vacancy'

export const Vacancies = axios => ({
  get (slug, filters) {
    const params = { ...filters }

    // Items may arrive as objects ({ slug, name }) or as already-mapped slugs
    params.categories = params?.categories?.map(_ => _?.slug ?? _)
    params.locations = params?.locations?.map(_ => _?.slug ?? _)
    params.industries = params?.industries?.map(_ => _?.slug ?? _)
    params.companies = params?.companies?.map(_ => _?.slug ?? _)

    return axios.get(`/v1/profiles/${slug}/vacancies/matching`, { params })
  },

  filters: {
    save (name, payload) {
      return axios.post('/v1/search-templates', {
        name,
        payload,
        type: FILTER_TYPE
      })
    },
    get (page, perPage) {
      const params = { type: FILTER_TYPE }

      if (page) params.page = page
      if (perPage) params.per_page = perPage

      return axios.get('/v1/search-templates', {
        params
      })
    },
    delete (id) {
      return axios.delete(`/v1/search-templates/${id}`)
    }
  },

  favorites: {
    get (profile, { cursor, page, perPage } = {}) {
      const params = {}
      if (cursor) params.cursor = cursor
      if (page) params.page = page
      if (perPage) params.per_page = perPage
      return axios.get(`/v1/profiles/${profile}/vacancies/favorites`, { params })
    },
    toggle (profile, vacancy) {
      return axios.patch(`/v1/profiles/${profile}/vacancies/favorites/${vacancy}`)
    }
  },

  process: {
    apply (profile, vacancy) {
      return axios.patch(`/v1/profiles/${profile}/vacancies/process/${vacancy}`)
    }
  }
})
